module.exports = __webpack_public_path__ + "static/media/iransans.ac22d187.ttf";